export default "__VITE_ASSET__mt_TlFX___"